module.exports = __webpack_public_path__ + "static/media/image-2.a74740a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-2.jpg
// module id = 255
// module chunks = 0